var OperationClass = (function () {
    function OperationClass() {
    }
    return OperationClass;
}());
//# sourceMappingURL=OperationClass.js.map